export const aboutus2 = {
  seo: {
    title: "Bespire - Rólunk",
    description: "A Bespire küldetése, hogy minden tartalomkészítő hozzáférjen a professzionális eszközökhöz és helyi támogatáshoz.",
    keywords: "creator monetization, AI tools for creators, European creator platform, sell digital products, subscription tools"
  },
  navigation: {
    home: "Főoldal",
    features: "Funkciók",
    about: "Rólunk",
    contact: "Kapcsolat",
    login: "Bejelentkezés",
    benefits: "Előnyök",
    getStarted: "Kezdjük el",
    pricingAndExperiences: "Árak és élmények"
  },
  hero: {
    title: "Erőt adunk az alkotóknak,",
    subtitle: "mindenhol",
    description: "A Bespire segít az európai és MENA régió alkotóinak, hogy szenvedélyüket fenntartható bevétellé alakítsák AI-alapú eszközökkel és helyi szakértelemmel.",
    cta: "Csatlakozz hozzánk",
    learnMore: "Tudj meg többet"
  },
  mission: {
    title: "Küldetésünk",
    description: "A Bespire küldetése, hogy minden tartalomkészítő hozzáférjen a professzionális eszközökhöz, amivel gyorsan és hatékonyan monetizálhatja munkáját – helyi fizetési megoldásokkal, nyelvi támogatással és mesterséges intelligenciával. Hiszünk abban, hogy a kreativitás nem ismer határokat, és minden alkotónak joga van a sikerhez."
  },
  story: {
    title: "Történetünk",
    timeline: [
      {
        year: "2023",
        title: "A kezdetek",
        description: "Megalapítottuk a Bespire-t azzal a céllal, hogy megoldjuk az európai alkotók legnagyobb kihívását: a helyi fizetési megoldások és nyelvi támogatás hiányát."
      },
      {
        year: "2024",
        title: "AI integráció",
        description: "Bevezettük az AI-alapú weboldal-építő eszközünket, amely lehetővé teszi az alkotók számára, hogy percek alatt professzionális weboldalt hozzanak létre."
      },
      {
        year: "Jövő",
        title: "Közösségépítés",
        description: "Folyamatosan bővítjük platformunkat új funkciókkal és eszközökkel, hogy támogassuk az alkotói közösség növekedését."
      }
    ]
  },
  values: {
    title: "Értékeink",
    items: [
      {
        title: "Innováció",
        description: "AI-alapú megoldások, amelyek egyszerűvé teszik a komplex folyamatokat",
        icon: "Brain"
      },
      {
        title: "Lokalitás",
        description: "Helyi nyelvek és fizetési módok támogatása minden régióban",
        icon: "Globe"
      },
      {
        title: "Egyszerűség",
        description: "Gyors indulás és könnyű használat, technikai tudás nélkül",
        icon: "Zap"
      },
      {
        title: "Közösség",
        description: "Erős alkotói ökoszisztéma és támogató környezet",
        icon: "Users"
      }
    ]
  },
  achievements: {
    title: "Mérföldkövek",
    subtitle: "Büszkék vagyunk az eddig elért eredményeinkre",
    items: [
      {
        title: "Teljes körű AI-vezérelt platform",
        description: "Az első olyan európai teljes körű platform, amely nemcsak AI-alapú weboldal készítést, hanem fizetést, számlázást, áfa kezelést és minden szükséges funkciót biztosít alkotóknak egy helyen"
      },
      {
        title: "Multiregionális támogatás",
        description: "Egész Európában aktív szolgáltatás helyi fizetési módokkal és nyelvi támogatással"
      },
      {
        title: "Technológiai innováció",
        description: "Mindig az aktuális technológiák adoptálása és integrálása a platform fejlesztésében"
      },
      {
        title: "Közösségépítés",
        description: "Aktív alkotói közösség építése workshopokkal, eseményekkel és mentorálással"
      }
    ]
  },
  whyChooseUs: {
    title: "Miért válassz minket?",
    subtitle: "A Bespire különlegessége, ami megkülönböztet minden más platformtól",
    items: [
      {
        title: "AI-vezérelt egyszerűség",
        description: "Míg mások bonyolult eszközöket kínálnak, mi az AI erejével tesszük egyszerűvé a weboldal készítést és az értékesítést.",
        icon: "Brain"
      },
      {
        title: "Helyi szakértelem",
        description: "Egész Európában helyi fizetési módok, nyelvek és kulturális ismeretek - nem csak egy globális megoldás másolata.",
        icon: "Globe"
      },
      {
        title: "Dedikált alkotói támogatás",
        description: "Speciálisan alkotókra szabott eszközök és személyes mentorálás - nem egy általános e-commerce platform.",
        icon: "Users"
      },
      {
        title: "Gyors eredmények",
        description: "Perceken belül működő weboldal és azonnali értékesítési lehetőség - nem hónapok várakozás fejlesztésre.",
        icon: "Zap"
      }
    ]
  },
  contact: {
    title: "Lépj kapcsolatba velünk",
    subtitle: "Készen állunk segíteni az alkotói utadon",
    description: "Bármilyen kérdésed van, vagy segítségre van szükséged, csapatunk készen áll rá, hogy támogasson.",
    methods: [
      {
        title: "Email támogatás",
        description: "hello@bespire.com",
        details: "Válaszidő: 2-4 óra munkanapokon"
      },
      {
        title: "Live chat",
        description: "Azonnali segítség",
        details: "Hétfő-péntek 9:00-18:00"
      },
      {
        title: "Közösség",
        description: "Discord szerver",
        details: "Csatlakozz az aktív alkotói közösséghez"
      }
    ]
  },
  statistics: {
    title: "Eredményeink számokban",
    subtitle: "Büszkék vagyunk az alkotói közösségünk sikerére",
    items: [
      {
        number: "15,000+",
        label: "Aktív alkotó",
        description: "Európa és MENA régió"
      },
      {
        number: "€2.5M+",
        label: "Generált bevétel",
        description: "Alkotók összesített bevétele"
      },
      {
        number: "95%",
        label: "Elégedettségi arány",
        description: "Alkotók ajánlanák tovább"
      },
      {
        number: "24h",
        label: "Átlagos beállítási idő",
        description: "Ötlettől az élő oldalig"
      }
    ]
  },
  testimonials: {
    title: "Mit mondanak alkotóink",
    subtitle: "Valós történetek valós alkotóktól",
    items: [
      {
        name: "Kovács Anna",
        role: "Lifestyle Blogger",
        content: "A Bespire-rel 3 hónap alatt 10x-re növeltem a bevételeimet. Az AI-asszisztens zseniális, másodpercek alatt kész az oldalam.",
        location: "Budapest, Magyarország"
      },
      {
        name: "Ahmed Hassan",
        role: "Fitness Coach",
        content: "Finally a platform that understands the MENA market. Local payment methods and Arabic support made all the difference.",
        location: "Dubai, UAE"
      },
      {
        name: "Marie Dubois",
        role: "Artist & Designer",
        content: "Je peux enfin vendre mes créations facilement. L'interface est intuitive et le support client exceptionnel.",
        location: "Paris, France"
      }
    ]
  },
  vision: {
    title: "Jövőképünk",
    subtitle: "Az alkotói gazdaság jövőjét építjük",
    description: "2030-ra a Bespire lesz Európa és a MENA régió vezető alkotói platformja. Célunk, hogy minden tehetséges embernek legyen lehetősége arra, hogy szenvedélyét fenntartható üzletté alakítsa - függetlenül attól, hol él vagy milyen nyelvet beszél.",
    goals: [
      "1 millió aktív alkotó a platformon",
      "50+ nyelv és helyi fizetési mód támogatása",
      "AI-alapú mentorálás minden alkotó számára",
      "Karbonsemleges működés 2028-ra"
    ]
  },
  team: {
    title: "Csapatunk",
    subtitle: "Tapasztalt szakemberek, akik hisznek az alkotói gazdaság jövőjében",
    members: [
      {
        name: "Kovács Péter",
        role: "Alapító & CEO",
        description: "10 év tapasztalat a tech iparágban, korábbi vezető pozíciók nemzetközi startupoknál."
      },
      {
        name: "Nagy Anna",
        role: "AI & Product Lead",
        description: "Mesterséges intelligencia szakértő, korábban vezető tech cégeknél dolgozott AI megoldásokon."
      },
      {
        name: "Szabó Márk",
        role: "Head of Creator Success",
        description: "Creator industry szakértő, segít az alkotóknak maximalizálni bevételeiket a platformon."
      },
      {
        name: "Tóth Eszter",
        role: "Head of Growth",
        description: "Marketing és növekedési stratégia szakértő, felelős a platform nemzetközi terjeszkedéséért."
      }
    ]
  },
    cta: {
    title: "Csatlakozz hozzánk!",
    description: "Kezdj el pénzt keresni a szenvedélyeddel még ma. AI-alapú eszközeinkkel percek alatt elindulhatsz."
  },
  footer: {
    description: "AI-alapú eszközökkel és helyi szakértelemmel segítünk alkotóknak mindenhol.",
    platform: "Platform",
    platformLinks: {
      home: "Főoldal",
      aiAssistant: "AI Asszisztens",
      pricing: "Árak"
    },
    support: "Támogatás",
    supportLinks: {
      help: "Segítség",
      documentation: "Dokumentáció",
      contact: "Kapcsolat"
    },
    legal: "Jogi",
    legalLinks: {
      terms: "Felhasználási feltételek",
      privacy: "Adatvédelmi szabályzat",
      cookies: "Cookie szabályzat"
    },
    copyright: "© 2024 Bespire. Minden jog fenntartva.",
    socialAlert: "Instagram profil hamarosan",
    twitterAlert: "Twitter profil hamarosan",
    subscribeAlert: "Köszönjük a feliratkozást! Hamarosan email formában fogjuk értesíteni a újdonságokról.",
    pricing: "Árazás",
    partnerProgram: "Partner Program",
    referralProgram: "Ajánlói program",
    aboutUs: "Rólunk"
  }
};